// extracted by mini-css-extract-plugin
module.exports = {"videoCanvas":"videoCanvas_videoCanvas__2VhkQ"};